var path = './approvals/listRequests/title_bar.html';
var html = "<div role=\"menu\" class=\"menu\" ng-if=\"authenticated\">\n    <div class=\"menu-row\">\n        <secondary-nav path=\"path\"></secondary-nav>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;